export { default } from "./RegisterIndustryConfirmation";
